<template>
  <li class="education-feedbacks-tab course-description-content">
    <div class="comments education-feedbacks">
      <h4>
        {{ $t("general.experience_sharing") }}
        <span class="comments-amount">
          ({{ comments.length }} {{ $t("education.Sharing") }})
        </span>
      </h4>
      <ul>
        <Comments v-for="(comment, index) in comments"
                  :id="'comment_' + comment.id"
                  :key="comment.id || 'comment_' + index"
                  :comment="comment.text"
                  :image="comment.user.photo_link"
                  :name="comment.user.name + ' ' + comment.user.surname"
                  :title="comment.user.position ? comment.user.position.name : ''"
        />
      </ul>
    </div>
  </li>
</template>

<script>
import Comments from "@/view/components/educationDetail/Comments";

export default {
  name: "EducationFeedbacksTab",
  components: {
    Comments,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    comments() {
      return Array.isArray(this.item.approved_comments)
          ? this.item.approved_comments.filter(
              (comment) => comment && comment.user
          )
          : [];
    },
  },
};
</script>

<style scoped>
.education-feedbacks {
  margin-top: 0 !important;
}

.education-feedbacks > ul {
  margin: 0;
  padding: 0;
}
</style>
